// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { arrowUpTwoRectangles } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-arrow-up-two-rectangles': IconArrowUpTwoRectangles;
    }
}

/**
 * The icon component for the 'arrowUpTwoRectangles' icon
 */
export class IconArrowUpTwoRectangles extends IconSvg {
    public constructor() {
        super(arrowUpTwoRectangles);
    }
}

registerIconSvg('icon-arrow-up-two-rectangles', IconArrowUpTwoRectangles);
export const iconArrowUpTwoRectanglesTag = 'nimble-icon-arrow-up-two-rectangles';
